module.exports = __webpack_public_path__ + "static/people-f78e200cde0e07e584d51fe2c0b18f4a.webp";